import { createContext, useContext, useRef, type ReactNode } from "react";

// Define the context type
interface RootContextType {
  contentQARootRef: React.RefObject<HTMLDivElement | null>;
}

// Provide a default value
export const RootProviderContext = createContext<RootContextType | undefined>(
  undefined,
);

export const RootProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const contentQARootRef = useRef<HTMLDivElement | null>(null);

  return (
    <RootProviderContext.Provider
      value={{
        contentQARootRef,
      }}
    >
      {children}
    </RootProviderContext.Provider>
  );
};

export const useRoot = () => {
  const context = useContext(RootProviderContext);
  if (!context) {
    throw new Error("useRoot must be used within a RootProvider");
  }
  return context;
};
